import {
    Application,
} from '_pixiSrc';
import {
    AssetsLibrary,
} from '_pixiSrc/media';
import SpineLibrary from '_pixiSrc/media/SpineLibrary';
import {
    Utils,
} from '_pixiSrc/Utils';
import {
    ASSETS_PATH,
    ASSETS_VERSION,
} from './Constants';

import AdMessage from './ui/AdMessage';
import GameScreen from './gameEngine/GameScreen';
import GlobalError from './ui/GlobalError';
import NeutrinoFX from './NeutrinoFX';

/**
 * @augments Application
 */
class Game extends Application {
    constructor(...rest) {
        super(...rest);

        this.currentWindow = null;

        SpineLibrary.atlasScale = 2;
        this.spineLibrary = new SpineLibrary(ASSETS_PATH.SPINE);

        this.ready = false;

        this.glovalErrorView = null;
    }

    init(container) { // TODO: a temporary hack for this game, over time, Dev redraws
        this.createLayout(container);

        this.layout.detectBitmapScale(this.config.scales);
        this.layout.autoFill = true;

        const GET = Utils.parseGet();

        if (GET.animation === 1) { this.layout.bitmapScale = 2; } else { this.layout.bitmapScale = 1.5; }

        this.library = new AssetsLibrary(ASSETS_PATH.IMAGES, this.layout.bitmapScale, ASSETS_VERSION);

        this.addStage();

        this.layout.fitLayout(true);
        this.layout.showPreloader();

        this.layout.on('hidewindow', () => {
            this.audio.pause();
        });
        this.layout.on('showwindow', () => {
            this.audio.resume();
        });

        /**
     * End initialization
     * @event Application#ready
     */
        this.external.init(() => this.emit('ready'));
    }

    run() {
        super.run();

        NeutrinoFX.init(this.stage.renderer, ['big', 'monster', 'legendary'], `${ASSETS_PATH.NEUTRINO}/`);

        this.ready = true;

        this.startGame();

        this.stage.screen.canvas.addEventListener('mousedown', () => {
            window.focus();
        });
    }

    closeCurrentWindow() {
        if (this.currentWindow) {
            this.stage.view.removeChild(this.currentWindow);
            this.currentWindow = null;
        }
    }

    showWindow(view) {
        this.closeCurrentWindow();
        this.stage.view.addChild(view);
        this.currentWindow = view;
        return view;
    }

    startGame() {
        this.showWindow(new GameScreen());
    }

    displayRewardedAd(id, data, autoReload = true, button1, button1Callback, button2, button2Callback) {
        if (this.glovalErrorView) { return; }

        this.glovalErrorView = this.stage.view.addChild(new AdMessage(id, data, autoReload, button1, button1Callback, button2, button2Callback));
        return this.glovalErrorView;
    }

    displayGlobalError(id, data, autoReload = true, buttonText = '', callback = () => { console.log('no callback'); }) {
        if (this.glovalErrorView) { return; }

        this.glovalErrorView = this.stage.view.addChild(new GlobalError(id, data, autoReload, buttonText, callback));
        return this.glovalErrorView;
    }

    tick(e) {
        super.tick(e);
        NeutrinoFX.update(e.delta / 1000);
        if (this.currentWindow.tick) { this.currentWindow.tick(e); }
    }
}

export default Game;
